export const types = {
  WHATSAPP: 'whatsapp',
  MESSENGER: 'messenger',
  FACEBOOK: 'facebook',
  TWITTER: 'x',
  EMAIL: 'email',
} as const;

export type SocialShareTypes = (typeof types)[keyof typeof types];

export const eventActions = {
  SHARE_BEGIN: 'ShareSellerProfileBegin',
};

export const eventLabelsByType: Record<string, string> = {
  [types.WHATSAPP]: 'Whatsapp',
  [types.MESSENGER]: 'Facebook-Messenger',
  [types.FACEBOOK]: 'Facebook',
  [types.TWITTER]: 'Twitter',
  [types.EMAIL]: 'Email',
};

export const utmSourcesByType: Record<string, string> = {
  [types.WHATSAPP]: 'whatsapp',
  [types.MESSENGER]: 'facebook-messenger',
  [types.FACEBOOK]: 'facebook',
  [types.TWITTER]: 'twitter_large',
  [types.EMAIL]: 'email',
};
